import makeQueryKey from "../../../../../utils/make-query-key";
import getWebShellClientLocale from "../../../../../utils/get-webshellclient-locale";

/**
 * Constructs a query key for the wishlist endpoint.
 * @param {Object} options - The options object.
 * @param {string} options.id - The list id.
 * @returns {Array} The complete query key array with namespaced queryKey as the first element.
 */
var getWishlistItemsQueryKey = function getWishlistItemsQueryKey() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    id = _ref.id;
  var _getWebShellClientLoc = getWebShellClientLocale(),
    country = _getWebShellClientLoc.country,
    marketplaceId = _getWebShellClientLoc.marketplaceId;
  var marketplace = marketplaceId || country.toUpperCase();
  return makeQueryKey(['buy/wishlists/v2/lists', {
    marketplace: marketplace,
    id: id
  }]);
};
export default getWishlistItemsQueryKey;